import WorkIcon from '@mui/icons-material/Work';

const ProfessionalStyle = {
  id: 'professional',
  name: 'Professional',
  description: 'A clean style with a focus structure.',
  icon: <WorkIcon />,
  settings: {
    useSectionIcons: false,
    useContactIcons: true,
    showSectionTitleBorder: true,
    sectionTitleBorderWidth: '1px', // Example width
  },
};

export default ProfessionalStyle; 